/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { useAuth } from "cms/auth/hooks/useAuth";
import { isArrayNotEmpty } from "cms/utils/empty-exists";
import { NavCardsSectionItem } from "./section_item";
import { SimpliCitySDK } from "cms/sdk";
import { RichText } from "cms/rich-text";
import { isRichTextNotEmpty } from "cms/utils/empty-exists";

const NavCardsSection = (props) => {
    const { component, webpage } = props;
    const { token } = useAuth();
    const webpage_guid = webpage?.guid;

    const [children, setChildren] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const description = component?.description;

    useEffect(() => {
        const executeAsync = async () => {
            if (!webpage_guid) {
                setLoading(false);
                return;
            }

            try {
                // Fetch webpage children directly using the SDK
                const response = await SimpliCitySDK.webpage.findChildren(token, webpage_guid);
                const _children = response?.children || [];

                if (_children && _children.length > 0) {
                    const enhancedChildren = await Promise.all(
                        _children.map(async (child) => {
                            try {
                                const childGuid = child?.guid;
                                const banner_image = await SimpliCitySDK.webpage.getWebpageBannerImage(token, childGuid);

                                return {
                                    ...child,
                                    banner_image: banner_image || null
                                };
                            // eslint-disable-next-line no-unused-vars
                            } catch (err) {
                                return {
                                    ...child,
                                    banner_image: null
                                };
                            }
                        })
                    );

                    setChildren(enhancedChildren);
                } else {
                    setChildren(children);
                }
                setError(null);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        executeAsync();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, webpage_guid]);


    const hasContent = isArrayNotEmpty(children);

    if (loading) {
        return <div className="simplicity-section-list">Loading...</div>;
    }

    if (error) {
        return <div className="simplicity-section-list-error">{error?.message || "An error occurred"}</div>;
    }

    if (!hasContent) {
        return <div className="simplicity-section-list">This page currently has no children.</div>;
    }

    return (
        <div className='simplicity-section-list'>
            <div className='simplicity-section-description'>
                {isRichTextNotEmpty(description) &&
                    <RichText richtext={description} />
                }
            </div>
            <div className='simplicity-section-list-body'>
                {children.map((item, index) => {
                    return (
                        <NavCardsSectionItem
                            key={index}
                            item={item}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export { NavCardsSection };
